import React from "react";

export const TrashCanIcon = () => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g opacity="0.4">
				<path
					d="M3.43684 15.2285C3.4549 15.6598 3.80977 16.0001 4.24134 16.0001H11.7584C12.1899 16.0001 12.5448 15.6598 12.5629 15.2285L13.0997 3.89624H2.90002L3.43684 15.2285ZM9.70029 6.71098C9.70029 6.53041 9.8467 6.38396 10.0274 6.38396H10.5505C10.731 6.38396 10.8775 6.53037 10.8775 6.71098V13.1854C10.8775 13.366 10.7311 13.5124 10.5505 13.5124H10.0274C9.84678 13.5124 9.70029 13.3661 9.70029 13.1854V6.71098ZM7.41127 6.71098C7.41127 6.53041 7.55769 6.38396 7.7383 6.38396H8.2614C8.44193 6.38396 8.58843 6.53037 8.58843 6.71098V13.1854C8.58843 13.366 8.44205 13.5124 8.2614 13.5124H7.7383C7.55773 13.5124 7.41127 13.3661 7.41127 13.1854V6.71098ZM5.12218 6.71098C5.12218 6.53041 5.26859 6.38396 5.4492 6.38396H5.97235C6.15292 6.38396 6.29937 6.53037 6.29937 6.71098V13.1854C6.29937 13.366 6.15296 13.5124 5.97235 13.5124H5.4492C5.26863 13.5124 5.12218 13.3661 5.12218 13.1854V6.71098Z"
					fill="white"
				/>
				<path
					d="M13.4572 0.82424H9.98935V0.168624C9.98935 0.0755184 9.91387 0 9.82073 0H6.17912C6.08601 0 6.01053 0.0755184 6.01053 0.168624V0.824201H2.54264C2.26356 0.824201 2.03735 1.05044 2.03735 1.32952V2.91694H13.9625V1.32956C13.9625 1.05048 13.7363 0.82424 13.4572 0.82424Z"
					fill="white"
				/>
			</g>
		</svg>
	);
};
